export function buildFileTree(files) {
  const fileTree = {}; // This will be our nested object

  files.forEach(file => {
    // 1. Clean the path, e.g., 'content/blogs/2023/post-1.md' -> 'blogs/2023/post-1.md'
    const relativePath = file.path.replace(/^content\//, '');
    const parts = relativePath.split('/'); // -> ['blogs', '2023', 'post-1.md']

    // 2. Walk through the parts to build the nested structure
    let currentLevel = fileTree;
    parts.forEach((part, index) => {
      // 3. If it's the last part, it's the file itself
      if (index === parts.length - 1) {
        // We store files in a special '_files' array to avoid name conflicts with folders
        if (!currentLevel._files) {
          currentLevel._files = [];
        }
        currentLevel._files.push({
          ...file,
          // Store the simple filename for easy display
          fileName: part
        });
      } else {
        // 4. It's a folder. Create it if it doesn't exist.
        if (!currentLevel[part]) {
          currentLevel[part] = {};
        }
        // 5. Move one level deeper for the next part
        currentLevel = currentLevel[part];
      }
    });
  });

  return fileTree;
}